// Refresh everything the PropStream Connect and Investor Outreach cards on the Account page read (ATAI-277).
// The two subscriptions change together: cancelling Connect also schedules Investor Outreach to end, Do Not
// Cancel on Investor Outreach can bring Connect back, and "cancel both" ends Connect too. Each card used to
// refresh only itself after its own action, so the other one stayed stale until a full page reload.
import { getBillingDashboardAPI, getLeadAutomatorAPI, getPlanDetails } from '../../data/user';
import { fetchInvestorOutreachEntitlement } from '../../data/investors';

export const refreshSubscriptionCards = (dispatch, userId) => {
  if (!userId) return;
  dispatch(getPlanDetails(userId));
  dispatch(getBillingDashboardAPI(userId)); // Connect status and cancel date
  dispatch(getLeadAutomatorAPI(userId)); // Connect plan rows
  dispatch(fetchInvestorOutreachEntitlement(userId, { force: true })); // Investor Outreach status and end date
};
